import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1068px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  a {
    cursor: pointer;
  }

  nav.menu > ul:after {
    content: '';
    display: table;
    clear: both;
  }

  nav.menu * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  nav.menu-link {
    display: none;
  }
  nav.menu {
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
    display: flex;
    flex-direction: row;

    justify-content: space-between;
    width: 100%;
  }

  nav.menu ul:nth-child(2) {
    > li ul.account-navbar {
      /* margin-left: -104px; */
    }
  }

  nav.menu ul {
    padding: 0px;
    margin: 0px;
    list-style: none;
    position: relative;
    display: inline-table;
    background-color: #097189;
    background-image: -webkit-gradient(
      linear,
      50% 0%,
      50% 100%,
      color-stop(0%, rgba(255, 255, 255, 0.2)),
      color-stop(100%, rgba(255, 255, 255, 0))
    );
    background-image: -webkit-linear-gradient(
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0)
    );
    background-image: -moz-linear-gradient(
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0)
    );
    background-image: -o-linear-gradient(
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0)
    );
    background-image: linear-gradient(
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0)
    );
    /* -webkit-box-shadow: 0 1px 0 rgba(255, 255, 255, 0.2) inset;
    -moz-box-shadow: 0 1px 0 rgba(255, 255, 255, 0.2) inset;
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.2) inset;
    z-index: 9999; */
  }
  nav.menu > ul > li {
    border-right: 1px solid #097189;
    -webkit-box-shadow: 1px 0 0 rgba(60, 137, 157, 0.2);
    -moz-box-shadow: 1px 0 0 rgba(60, 137, 157, 0.2);
    box-shadow: 1px 0 0 rgba(60, 137, 157, 0.2);
  }
  nav.menu > ul > li:last-child {
    float: right;
    border: none;
    -webkit-box-shadow: 1px 0 0 rgba(60, 137, 157, 0.2);
    -moz-box-shadow: 1px 0 0 rgba(60, 137, 157, 0.2);
    box-shadow: 1px 0 0 rgba(60, 137, 157, 0.2); /* #3C899D */
  }

  /* nav.menu > ul > li:nth-last-of-type(2) {
    border-right: none;
  } */
  nav.menu > li > ul.sub-menu {
    min-width: 10em;
    padding: 4px 0;
    display: block;
    background-color: #097189;
    border: 1px solid rgba(0, 0, 0, 0.2);
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    -webkit-background-clip: padding-box;
    -moz-background-clip: padding;
    background-clip: padding-box;
  }

  nav.menu ul:after {
    content: '';
    clear: both;
    display: block;
  }
  nav.menu li:hover > a,
  nav.menu li.active,
  nav.menu li > a:focus {
    color: #fff;
    background-color: #3c899d !important;
    display: inline-block;
  }
  nav.menu > ul > li {
    display: inline-block;
  }
  nav.menu ul li a {
    display: block;
    text-decoration: none;
    color: #ffffff;
    font-size: 0.9em;
  }
  nav.menu ul li > a {
    height: 4.25em;
    padding: 20px 20px;
  }

  nav.menu ul ul {
    display: none;
    position: absolute;
    top: 100%;
    min-width: 160px;
    background-color: #097189;
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
  }

  nav.menu ul li:hover > ul {
    display: block;
  }
  nav.menu ul ul > li {
    position: relative;
  }
  nav.menu ul ul > li a {
    display: block;
    padding: 1em;
    height: auto;
    background-color: #097189;
    border-bottom: 1px solid #3c899d;
    -webkit-transition: background-color 0.2s ease-out;
    -moz-transition: background-color 0.2s ease-out;
    -ms-transition: background-color 0.2s ease-out;
    -o-transition: background-color 0.2s ease-out;
    transition: background-color 0.2s ease-out;
    width: 100%;
    min-width: 160px;
  }

  nav.menu ul ul ul {
    position: absolute;
    left: 100%;
    top: 0;
  }
  nav.menu ul ul ul > li a {
    display: block;
    padding: 0.8em;
  }
`;

export const BoxUser = styled.div`
  display: flex;
  > div {
    display: flex;
    flex-direction: column;
    text-align: right;
    margin-right: 10px;
    > span {
      margin-top: -5px;
    }
  }
`;
